import { ReactNode } from "react";

import Styled from "./index.styles";

export function CouponCard({
  icon,
  desc,
  delay,
  isActivatedTarget,
}: {
  icon: ReactNode;
  desc: ReactNode;
  delay: number;
  isActivatedTarget: boolean;
}) {
  return (
    <Styled.couponCard
      className={`fade-up-animation ${isActivatedTarget ? "active" : ""}`}
      delay={delay}
    >
      {icon}
      <p>{desc}</p>
    </Styled.couponCard>
  );
}
